import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCookieConsent } from './CookieConsentContext';
import { initGA, disableGA, trackPageView } from '../../configuration/analytics';

/**
 * Binds Google Analytics to the consent state and to the router.
 *
 * Renders nothing. Loading and unloading GA lives here rather than in the
 * consent context so that the context stays a plain state container and the
 * analytics dependency sits in one place.
 */
export const GoogleAnalytics: React.FC = () => {
  const location = useLocation();
  const { cookiePreferences } = useCookieConsent();
  const analyticsAllowed = cookiePreferences.analytics;

  useEffect(() => {
    if (analyticsAllowed) {
      initGA();
    } else {
      disableGA();
    }
  }, [analyticsAllowed]);

  // One page view per navigation, but only while consent stands.
  useEffect(() => {
    if (!analyticsAllowed) return;
    trackPageView(location.pathname + location.search, document.title);
  }, [analyticsAllowed, location.pathname, location.search]);

  return null;
};
